import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { LessorRepTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-lessor-rep-type',
  templateUrl: './lessor-rep-type.component.html',
  styleUrls: ['./lessor-rep-type.component.scss'],
})
export class LessorRepTypeComponent implements OnChanges {
  lessorreptypeForm: FormGroup;
  lessorreptypeFormArray: FormGroup;
  control = new FormControl();
  @Input() lessorreptypes: LessorRepTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() lessorreptype = new EventEmitter<LessorRepTypeDto[]>();
  @Output() deleteLessorRepTypeEvent = new EventEmitter<any>();

  selectedLessorRepType: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createLessorRepTypeForm();
  }

  createLessorRepTypeForm() {
    this.lessorreptypeForm = this.fb.group({
      LessorRepName: ['', Validators.required],
      id: null,
    });
    this.lessorreptypeFormArray = this.fb.group({
      LessorRepTypes: this.fb.array([]),
    });
    this.setLessorRepType();
  }

  // method to display lessorreptypes
  setLessorRepType() {
    const control = this.lessorreptypeFormArray.controls
      .LessorRepTypes as FormArray;
    this.lessorreptypes.forEach((e) => {
      control.push(
        this.fb.group({
          LessorRepName: e.LessorRepName,
          id: e.id,
        })
      );
    });
  }

  // method to add LessorRepType
  addLessorRepType(value: LessorRepTypeDto) {
    const control = this.lessorreptypeFormArray.controls
      .LessorRepTypes as FormArray;
    control.insert(
      0,
      this.fb.group({
        LessorRepName: value.LessorRepName,
        id: null,
      })
    );
  }

  selectLessorRepType(value) {}

  // method to delete lessorreptype from arrary list
  deleteLessorRepType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.lessorreptypeFormArray.controls
          .LessorRepTypes as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.lessorreptypes.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.lessorreptypes[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: LessorRepTypeDto) {
    if (this.lessorreptypeForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.lessorreptypeFormArray
        .get('LessorRepTypes')
        ['controls'][this.selectedIndex].patchValue({
          LessorReName: formValue.LessorRepName,
        });
    } else {
      this.addLessorRepType(formValue);
    }
    this.selectedIndex = null;
    this.lessorreptypeForm.reset();
  }

  onEdit(index, value: LessorRepTypeDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.lessorreptypeForm.patchValue({
      LessorRepName: value.LessorRepName,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.lessorreptypeForm.reset();
  }

  onSubmit(formValue: LessorRepTypeDto[]) {
    this.lessorreptype.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteLessorRepTypeEvent.emit(this.filteredDelete);
    }
  }
}
